import { render } from "./delete_account.vue?vue&type=template&id=12a71a2b"
import script from "./delete_account.vue?vue&type=script&lang=js"
export * from "./delete_account.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__